import DataRoomNodeActionsProvider from './DataRoomNodeActions.provider';

export default DataRoomNodeActionsProvider;
